import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=27017e6d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=27017e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27017e6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27017e6d')) {
      api.createRecord('27017e6d', component.options)
    } else {
      api.reload('27017e6d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=27017e6d&scoped=true&", function () {
      api.rerender('27017e6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CwgHlJIak6AM/JS/comp/Voucher.vue"
export default component.exports